import '@styles/pages/search.scss';

import { initSelectionBusHandler } from '@organisms/selection-bus-handler';
import { selectionSliderManager } from '@organisms/selection-slider-manager';
import { googlePlacesHelpers } from '@tools/geoservices/google-places-helpers';

window.googlePlacesHelpers = googlePlacesHelpers;

initSelectionBusHandler();
selectionSliderManager();
